import { render, staticRenderFns } from "./Goal.vue?vue&type=template&id=611ce16c"
import script from "./Goal.vue?vue&type=script&lang=js"
export * from "./Goal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports